import { useState, useEffect } from "react";
import { listenToAuthState } from "../Services/firebase/auth";
import { User } from "firebase/auth";
import { useDispatch } from "react-redux";
import { setUserDoc, setUserId } from "src/Store/reducers/userSlice";
import { getUserDoc } from "src/Services/firebase/firestore/user_doc";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { updateUser } from "src/Store/reducers/paddleSlice";
import { initClickConnectorWidget, clearClickConnectorUser } from "src/Services/clickconnector";
import { setSentryUser } from "src/Services/sentry";

export function useAuth() {
	const [authState, setAuthState] = useState({
		isSignedIn: false,
		pending: true,
		user: null as User | null,
	});

	const dispatch = useDispatch();
	const sendDataToGTM = useGTMDispatch();

	useEffect(() => {
		const unregisterAuthObserver = listenToAuthState(
			async (user: User | null) => {
				setAuthState({ user, pending: false, isSignedIn: !!user });
				setSentryUser(user);
				dispatch(setUserId(user?.uid || null));
				sendDataToGTM({ event: "start_pw", pw_user_email: user?.email });
				if (user) {
					const userDoc = await getUserDoc();
					dispatch(setUserDoc(userDoc));
					dispatch(updateUser({ id: userDoc._.paddleUserId }));
					// Initialize ClickConnector widget with verified user
					initClickConnectorWidget().catch((error) => {
						console.error("Failed to initialize ClickConnector:", error);
					});
				} else {
					dispatch(setUserDoc(null));
					dispatch(updateUser({ id: undefined }));
					// Clear ClickConnector user on logout
					clearClickConnectorUser();
				}
			}
		);
		return () => unregisterAuthObserver();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch]);

	return { ...authState };
}
